import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=60fed350&"
import script from "./TheLayout.vue?vue&type=script&lang=js&"
export * from "./TheLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60fed350')) {
      api.createRecord('60fed350', component.options)
    } else {
      api.reload('60fed350', component.options)
    }
    module.hot.accept("./TheLayout.vue?vue&type=template&id=60fed350&", function () {
      api.rerender('60fed350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/TheLayout.vue"
export default component.exports